// src/services/vaultAdmin.js — setting, changing, and taking away the code.
//
// 🟥 REMOVING A CODE IS THE DANGEROUS ONE, and it is dangerous in a quiet way.
//    Delete the wrapped key while sealed records remain and the bytes stay on
//    disk looking exactly like data, with the only thing that could ever open
//    them gone. Nothing errors, nothing is missing, and the loss is discovered
//    later. So the data is freed FIRST and the key is deleted LAST — and if the
//    freeing fails, the key stays.
//
// 🟢 AND A HALF-DONE REMOVAL IS SAFE, WHICH IS WHY IT CAN BE OFFERED AT ALL. Each
//    record says whether it is sealed and both readers handle either shape, so
//    stopping partway leaves a mixture that simply works. The alternative was
//    wiping the caches on removal, which would make "I don't want a code any
//    more" cost somebody every photo they had loaded.

import {
  isEnrolled, isUnlocked, canSeal, lock, enrollWithPin, unlockWithPin, deleteVaultRecord,
} from '../crypto/vault';
import { unsealAll } from './mediaStore';
import { unsealAllHistory } from './historySync';

export { isEnrolled, isUnlocked, unlockWithPin, lock };

/** What the settings menu may offer right now. */
export async function vaultState() {
  const enrolled = await isEnrolled().catch(() => false);
  if (!enrolled) return 'off';
  return isUnlocked() ? 'unlocked' : 'locked';
}

/** First time: create the vault. Everything written from here on is sealed. */
export async function setCode(pin) {
  await enrollWithPin(pin);
}

/**
 * 🟢 CHANGING THE CODE RE-WRAPS THE SAME DATA KEY — it does not re-encrypt
 *    anything, which is the entire reason the key is wrapped rather than derived
 *    and used directly. It requires the vault to be OPEN, so possession of the
 *    old code is proven by the fact that it is.
 */
export async function changeCode(newPin) {
  if (!canSeal()) throw new Error('Unlock first.');
  await enrollWithPin(newPin);
}

/**
 * Take the code away and leave the caches readable.
 *
 * 🟥 ORDER IS THE SAFETY. Unseal, verify nothing threw, then delete the key.
 */
export async function removeCode() {
  if (!canSeal()) throw new Error('Unlock first.');
  const media = await unsealAll();
  const history = await unsealAllHistory();
  await deleteVaultRecord();
  return { media, history };
}

/**
 * 🟢 LOCK NOW, WITHOUT WAITING FOR THE IDLE TIMER. "I am walking away from this
 *    machine" is a thing a person knows well before any timer could infer it,
 *    and a lock you cannot ask for is a lock you do not trust.
 */
export function lockNow() { lock(); }
